module.exports = __webpack_public_path__ + "static/sygnet_color_right-c34ac192d99f4f37a06597843a11e16e.svg";